import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import * as CryptoJS from 'crypto-js';
import { RequestModel } from '../model/SuperAdmin/User';
import { SearchValueInTableModel } from '../model/AdminArea';
import { from, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSettings } from '../model/SuperAdmin/GlobalSetting';

import { config } from '../../assets/config.js';
declare var CryptoJS;
//const crypto = require('crypto');
//declare var CryptoJS;
//import * as CryptoJS from 'crypto-js';
//import * as CryptoJS;
//declare var CryptoJS;
@Injectable({
  providedIn: 'root'
})

export class UtilitiesService {
  //=============Key for Crypto encode=========

  ShowHideBalancePop:boolean=true;
  isLoggedIn:boolean=false;
  isShowloader: boolean = false;
  reqmodel: RequestModel = new RequestModel();
  private key = CryptoJS.enc.Utf8.parse('_Simson@SWapUAE_');
  private iv = CryptoJS.enc.Utf8.parse('_Simson@SWapUAE_');
  public currentModuleId: number = 1;
  //==================END=================
  //Url="http://localhost:51069/";
  //===For Simple Url 
  //Url = config.apiurl;
  Url="";
  IsDMS:boolean=false;
  
  //Read encypted key
  //Url=this.decryptUsingAES256(config.apiurl);


  headers = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  constructor(private http: HttpClient) { }
  PageSize: number = 50;
  //=========Common Method For Post Request Without Header pass=========
  PostRequest(Url: any, model: any) {

    //this.reqmodel.EncryptString=this.encryptUsingAES256(JSON.stringify( model)).toString();
    //var data = {"EncryptString":this.encryptUsingAES256(model)};
    return this.http.post(Url, model, this.headers);
  }


  GetDate(date) {
   
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))

  }

  
   IstokenExpired() {
  
    var decrpyt=JSON.parse( localStorage.getItem('token'));
    var token=decrpyt.token;
  
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }

  //============Get Api Url Json

   getApiUrlJSON(): Observable<any> {
    return this.http.get("../../assets/url.json");
}


  GetPublicIpAddress() {
    return this.http.get("https://api.ipify.org/?format=json");

  }

  ParseResponse(res) {
    return JSON.parse(JSON.stringify(res));
  }

  //=========Common Method For Post Request With Header pass=========

  PostRequestWithformData(url: string, formData: FormData) {
    return this.http.post(url, formData);  // Sending POST request with FormData as the body
  }

  
  PostRequestWithheader(Url: any, model: any) {
    model.CompanyId = this.GetCompanyId();
    model.IUser = this.GetLoginUserId();
    model.EmpCode=this.GetLoginEmployeeCode();
    // this.reqmodel.EncryptString=this.encryptUsingAES256(JSON.stringify( model)).toString();
    // //console.log(this.reqmodel.EncryptString);
    // var data = {"EncryptString":this.encryptUsingAES256(model)};

    if (!model.EmpCode) {

      //    model.EmpCode=this.GetLoginEmployeeCode();
    }
    model.IUser = this.GetLoginUserId();
    var tokendata = JSON.parse(localStorage.getItem("token"));

    let regheaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'username':tokendata.user.UserName,
        'Authorization': 'Bearer ' + tokendata.token
      })
    }
    //return this.http.post(Url,  model,regheaders).pipe(catchError(this.errorHandler));
    return this.http.post(Url, model, regheaders);
  }
  //============Send Form Data With Files============

  UploadExcelFile(Url: any, formData: FormData) {
    var tokendata = JSON.parse(localStorage.getItem("token"));
   // formData.append('CompanyId', this.GetCompanyId());
    //formData.append('IUser', this.GetLoginUserId());
    let regheaders = {
      headers: new HttpHeaders({
        //'enctype': 'multipart/form-data',
        'Authorization': 'Bearer ' + tokendata.token
      })
    }
    return this.http.post(Url, formData, regheaders);
  }

  //=============END=========================

  //===========Read Json File==

  public getJSON(): Observable<any> {
    return this.http.get("./assets/userlogindetail.json");
  }

  getAmountDigit() {
    return 3;
  }
  //==========Generate Random Password===

//============GET CURRENCY ===========
GetCurrencyId()
{
  var res = JSON.parse(localStorage.getItem('token'));
  if (res != null) {
   return res.FinanceSettings.CurrencyId;

  } 
 }
  generatePassword(length, isUpper, isNumbers, isSymbols) {
    const passwordLength = length + 1 || 10;
    const addUpper = isUpper;
    const addNumbers = isNumbers;
    const addSymbols = isSymbols;

    const lowerCharacters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    const upperCharacters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const symbols = ['!', '?', '@', '#', '$', '&'];

    const getRandom = array => array[Math.floor(Math.random() * array.length)];

    let finalCharacters = '';

    if (addUpper) {
      finalCharacters = finalCharacters.concat(getRandom(upperCharacters));
    }

    if (addNumbers) {
      finalCharacters = finalCharacters.concat(getRandom(numbers));
    }

    if (addSymbols) {
      finalCharacters = finalCharacters.concat(getRandom(symbols));
    }

    for (let i = 1; i < passwordLength - 3; i++) {
      finalCharacters = finalCharacters.concat(getRandom(lowerCharacters));
    }

    return finalCharacters.split('').sort(() => 0.5 - Math.random()).join('');
  }



  //===== Create pattern from db value and return pattern =====//
  GetPattern(dbvalue) {

    var patteren = "^";
    //var dbvalue="2-N,2-N,2-N";
    var st = dbvalue.split(',');
    var check = 0;
    for (var i = 0; i < st.length; i++) {
      var st2 = st[i].split('-');
      if (st2[1] == "N") {
        patteren += "[1-9]{" + st2[0] + "}";
      }
      if (st2[1] == "A") {
        //patteren+="[A-Za-z]{"+st2[0]+"}";
        patteren += "[A-Za-z]{" + st2[0] + "}";
      }

      if (i + 1 < st.length) {
        patteren += "([\w-])";
      }
    }
    //console.log("pat"+patteren);
    return patteren;

  }

  //=========Get max length For text box
  GetMaxlength(dbvalue, dbmax) {
    var st = dbvalue.split(',');
    return (dbmax + (st.length - 1));

  }

  //============Get Placholder 

  GetPlaceholder(dbvalue) {
    if (dbvalue) {



      let upperCharacters: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      let numbers: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
      var st = dbvalue.split(',');
      var patteren = "";
      for (var i = 0; i < st.length; i++) {
        var st2 = st[i].split('-');
        if (st2[1] == "N") {
          for (var k = 0; k < st2[0]; k++) {
            patteren += numbers[k];

          }
          patteren += "-";

          // patteren+="[1-9]{"+st2[0]+"}";
        }
        if (st2[1] == "A") {
          for (var k = 0; k < st2[0]; k++) {
            patteren += upperCharacters[k];

          }
          patteren += "-";
        }
      }
      if (patteren.length > 0) {
        patteren = patteren.substring(0, patteren.length - 1);
      }

    }

    return patteren;
  }



  //===========Get Global Setting=======



  GetGlobalSetting() {
    var objSetting = new GlobalSettings();
    var objSettingModel = new GlobalSettings();
    objSetting.CompanyId = this.GetCompanyId();
    var response = [];
    this.PostRequestWithheader(this.Url + "superadmin/getglobalsetting", objSetting).subscribe(resp => {
      var res = this.ParseResponse(resp);
      if (res.Response.Status) {
        this.isShowloader = false;
        if (res.GlobalSetting != null) {
          return objSettingModel = res.GlobalSetting[0];

        }

      }

    });


  }


  //=======Return Mask for Input=
  GetMaskForInput(inputvalue, dbvalue) {

    var st = dbvalue.split(',');
    var value = "";
    for (var i = 0; i < st.length; i++) {
      var st2 = st[i].split('-');
      value += st2[0] + ",";

    }

    if (value.length > 0) {

      value = value.substring(0, value.length - 1);
    }
    var arr = JSON.parse("[" + value + "]");


    var retValue = inputvalue.replace(/-/g, "");
    if (retValue.length > 0) {
      retValue = this.format(retValue, arr, "-");
    }
    return retValue;

  }

  format(input, format, sep) {
    var output = "";
    var idx = 0;
    for (var i = 0; i < format.length && idx < input.length; i++) {
      output += input.substr(idx, format[i]);
      if (idx + format[i] < input.length) output += sep;
      idx += format[i];
    }

    output += input.substr(idx);

    return output;
  }





  /** Error Handling method */

  errorHandler(error: HttpErrorResponse) {

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,


    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }


  //==============Generate Header For Request==
  GetHeader() {
    var tokendata = JSON.parse((localStorage.getItem("token")));
    var headers = new Headers();
    headers.append("username", "asdasdsad");
    headers.append("token", tokendata.Token);
    return headers;
  }

  // Methods for the encrypt and decrypt Using AES
  encryptUsingAES256(model) {
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse((model)), this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted;
  }

  encryptPassword(password) {
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse((password)), this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted;
  }

  //==============Method for decrypt Using AES
  decryptUsingAES256(decString) {
    var decrypted = CryptoJS.AES.decrypt(decString, this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  //=========Get Company Id============
  GetCompanyId() {
    var res = JSON.parse(localStorage.getItem('token'));
    if (res != null) {
      // var res=JSON.parse(decrptresponse);
      return res.partyMaster.CompanyId;
    }
  }

  //=============Get FID===============
  GetFId(){
    var res = JSON.parse(localStorage.getItem('token'));
    if(res != null){
      return res.FinancePeriodMaster.Fid;
    }
  }

  //=========Get Company Id============
  GetLoginUserId() {
    var res = JSON.parse(localStorage.getItem('token'));
    if (res != null) {
      // var res=JSON.parse(decrptresponse);
      return res.partyMaster.contactPerson[0].FirstName;
    }

  }

  //=========Get Employeee Code============
  GetLoginEmployeeCode() {
    var res = JSON.parse(localStorage.getItem('token'));
    if (res != null) {
      // var res=JSON.parse(decrptresponse);
      return res.partyMaster.PartyCode;
    }

  }

  //===============Get Login User Role ID

  GetLoginUserRoleId() {
    var decrptresponse = this.decryptUsingAES256(localStorage.getItem('token'));
    if (decrptresponse != "") {
      var res = JSON.parse(decrptresponse);
      return res.Userdetail.RoleId;
    }
  }

  //===========Get Common Date Format=======
  GetDateFormat() {

    return "dd-MM-yyyy";
  }

  GetDateTimeFormat() {

    return "dd-MM-yyyy HH:mm";
  }
  //=============Get User Modules after login for Bind Left Menu=======
  GetLoginUserModule() {
    var decrptresponse = this.decryptUsingAES256(localStorage.getItem('token'));
    if (decrptresponse != "") {
      var res = JSON.parse(decrptresponse);
      return res.Userdetail.Roles;
    }
  }

  //==============Check User Right to access perticular url===

  CheckUserRight(url) {

    if (url == "/dashboard") {
      return true;
    }
    else {
      var decrptresponse = this.decryptUsingAES256(localStorage.getItem('token'));
      if (decrptresponse != "") {
        var res = JSON.parse(decrptresponse);
        if (res.Userdetail.Roles != "") {
          var allrole = JSON.parse(res.Userdetail.Roles);
          var filetr = allrole.filter(
            // item => item.ModuleName.tolower().indexOf(url.tolower())>0 && item.Status===true );
            item => item.PageUrl === url && item.Status === true);
          if (filetr.length > 0)
            return true;
          else
            return false;
        }
      }
      return false;
    }
  }

  //==========Check User Right for Addtion,Updation and Deletion=====
  checkUserPermisson(id) {


    var splitids = id.split('_');
    var res = JSON.parse(localStorage.getItem('token'));
    if (res.Role.Roles != "") {

      var allrole = JSON.parse(res.Role.Roles);
      var filetr = allrole.filter(
        // item => item.ModuleName.tolower().indexOf(url.tolower())>0 && item.Status===true );
        item => item.Status === true && item.FormCode === id);
      return filetr;


    }
  }

///============Check Approver==========

checkApprover(id) {


  var splitids = id.split('_');
  var res = JSON.parse(localStorage.getItem('token'));
  if (res.Role.Roles != "") {

    var allrole = JSON.parse(res.Role.Roles);
    var filetr = allrole.filter(
      // item => item.ModuleName.tolower().indexOf(url.tolower())>0 && item.Status===true );
      item => item.Status === true && item.FormCode === id);
    return filetr;


  }
}
  //================== function for numeric validation =====================//

  NumericField() {
    var NumberOnly = (event: any) => {
      if (event.keyCode < 48 || event.keyCode > 57) {
        event.preventDefault();
      }
    }
    return NumberOnly;
  }


  //===========Function For Comma Seprated in Amount Fields======

  

  //================== function for Decimal validation =====================//

  NumericDecimalField() {
   
    var res = JSON.parse(localStorage.getItem('token'));
    var MaxDecimallength =2;
   
    var Decimal = (event: any) => {
      if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 46 || event.keyCode > 46)) {
        event.preventDefault();
      }
      else {
        if (event.target.value == "" && event.keyCode == 46) { event.preventDefault(); } else {
          if (event.target.value != "") {
            if (event.target.value.includes('.') && event.keyCode == 46) {
              event.preventDefault();
            }
            else
            {
              if(event.target.value.includes('.')){
                var Value = event.target.value.split('.');
                var Valuelength = Value[1].length;
                if(Valuelength + 1 > MaxDecimallength) {
                  event.preventDefault();
                }
              }
            }
          }
        }
      }
    }
    return Decimal;
  }
  //================== function for numeric plus validation =====================//

  NumericPlusField() {
    var NumberPlus = (event: any) => {
      if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 43 || event.keyCode > 43)) {
        event.preventDefault();
      }else{
        if (event.target.value != "") {
          if (event.target.value.includes('+') && event.keyCode == 43) {
            event.preventDefault();
          }
        }
      }
    }
    return NumberPlus;
  }

  //Search multiple object on mat table
  nestedFilterCheck(search, data, key) {
    if (typeof data[key] === 'object') {
      for (const k in data[key]) {
        if (data[key][k] !== null) {
          search = this.nestedFilterCheck(search, data[key], k);
        }
      }
    } else {
      search += data[key];
    }
    return search;
  }


}
